import { FaceSmileIcon, FaceIcon, FaceFrownIcon } from '@navikt/aksel-icons';

export const formatShortDate = (dateString: string): string => {
  const date = new Date(dateString);
  return new Intl.DateTimeFormat('nb-NO', {
    day: '2-digit',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit',
  }).format(date);
};

const SENTIMENT_COLORS = {
  POSITIVE: 'var(--ds-color-success-base-default)',
  NEUTRAL: 'var(--ds-color-warning-base-default)',
  NEGATIVE: 'var(--ds-color-danger-base-default)',
} as const;

const AVERAGE_THRESHOLDS = {
  HIGH: 3.5,
  MEDIUM: 2.5,
} as const;

export const getSentimentFromAverage = (average: number): {
  icon: typeof FaceSmileIcon | typeof FaceIcon | typeof FaceFrownIcon;
  color: string;
  score: number;
} => {
  const roundedScore = Math.round(average * 10) / 10;

  if (average >= AVERAGE_THRESHOLDS.HIGH) {
    return {
      icon: FaceSmileIcon,
      color: SENTIMENT_COLORS.POSITIVE,
      score: roundedScore,
    };
  }

  if (average >= AVERAGE_THRESHOLDS.MEDIUM) {
    return {
      icon: FaceIcon,
      color: SENTIMENT_COLORS.NEUTRAL,
      score: roundedScore,
    };
  }

  return {
    icon: FaceFrownIcon,
    color: SENTIMENT_COLORS.NEGATIVE,
    score: roundedScore,
  };
};
